import {showNotification} from 'platform/components';

import {
  CompleteMicrosoftOAuth2ApiResponse,
  useCreateMicrosoftOAuth2CredentialsMutation,
} from '@dms/api/core';
import {
  CONFIG_STORAGE_KEY,
  EMAIL_CREDENTIALS_EDIT_QUERY_PARAM,
  OAuthConfig,
} from '@dms/features/email-smtp';
import {settingsRoutes, myProfileRoutes} from '@dms/routes';
import {handleApiError} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

export const useFinishEmailOAuth = (config: OAuthConfig) => {
  const [
    createMicrosoftOAuth2Credentials,
    {
      isError: isErrorCreateMicrosoftOAuth2Credentials,
      error: errorCreateMicrosoftOAuth2Credentials,
    },
  ] = useCreateMicrosoftOAuth2CredentialsMutation();

  const navigate = useNavigate();

  const finish = async (response: CompleteMicrosoftOAuth2ApiResponse) => {
    await createMicrosoftOAuth2Credentials({
      createMicrosoftOAuth2CredentialsRequestBody: {
        ownerType: config.ownerType ?? 'tenant',
        oAuthTokenId: response.microsoftTokenId,
        emailAddress: response.identity.email ?? '',
        title: response.identity.email ?? response.identity.displayName ?? 'Microsoft',
      },
    })
      .unwrap()
      .then((createdCredentials) => {
        const emailServicesRoute =
          config.ownerType === 'tenant'
            ? settingsRoutes.emailServices
            : myProfileRoutes.emailServices;

        showNotification.success();
        navigate(
          composePath(emailServicesRoute, {
            queryParams: {[EMAIL_CREDENTIALS_EDIT_QUERY_PARAM]: createdCredentials.id},
            isSearchParamsPreserved: false,
          })
        );
        localStorage.removeItem(CONFIG_STORAGE_KEY);
      })
      .catch(handleApiError);
  };

  return [
    finish,
    {
      isError: isErrorCreateMicrosoftOAuth2Credentials,
      error: errorCreateMicrosoftOAuth2Credentials,
    },
  ] as const;
};
